document.querySelectorAll('.shop-the-look__wrapper').forEach((wrapper) => {
  const dots = wrapper.querySelectorAll('.shop-the-look__dot');
  const slider = wrapper.querySelector('.shop-the-look__products');
  if (!dots.length || !slider) return;

  const slides = slider.querySelectorAll('.shop-the-look__product');

  const setActiveDot = (index) => {
    dots.forEach((dot, i) => {
      dot.classList.toggle('shop-the-look__dot--active', i === index);
      dot.setAttribute('aria-expanded', i === index ? 'true' : 'false');
    });
  };

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const target = slides[index];
      if (!target) return;
      slider.scrollTo({
        left: target.offsetLeft - slider.offsetLeft,
        behavior: 'smooth',
      });
      setActiveDot(index);
    });
  });

  // Keep dots in sync when the slider is scrolled via its own prev/next buttons or swipe
  let scrollTimeout;
  slider.addEventListener('scroll', () => {
    window.clearTimeout(scrollTimeout);
    scrollTimeout = window.setTimeout(() => {
      let closestIndex = 0;
      let closestDistance = Infinity;
      slides.forEach((slide, i) => {
        const distance = Math.abs(slide.offsetLeft - slider.offsetLeft - slider.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      setActiveDot(closestIndex);
    }, 100);
  });
});
